var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('y-header-expert'),_c('div',{staticClass:"main-content"},[_c('router-view')],1),_c('y-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }